"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var StickyCTA_1 = __importDefault(require("./StickyCTA"));
var FooterModal = /** @class */ (function (_super) {
    __extends(FooterModal, _super);
    function FooterModal() {
        var _this = this;
        var _a;
        _this = _super.call(this, constants_1.DATA_FOOTER) || this;
        if (!_this.getElement())
            return _this;
        _this.modal = _this.getElement().querySelector("[".concat(constants_1.DATA_CONTACT_MODAL, "]"));
        _this.buttonClose = (_a = _this.modal) === null || _a === void 0 ? void 0 : _a.querySelector("[".concat(constants_1.DATA_CONTACT_MODAL_CLOSE, "]"));
        _this.buttons = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_CONTACT_BUTTON, "]"));
        _this.initEventListeners();
        return _this;
    }
    FooterModal.prototype.checkForOutsideClick = function (event) {
        var elements = event.composedPath();
        // -2 because we want to skip document and window (unless you are not using document as parent)
        for (var i = 0; i < elements.length - 2; i++) {
            var el = elements[i];
            if (el === null || el === void 0 ? void 0 : el.classList.contains(constantsClasses_1.CLASS_FOOTER_MODAL__CONTENT))
                return;
        }
        this.closeModal();
    };
    FooterModal.prototype.initEventListeners = function () {
        var _this = this;
        var _a;
        (_a = this.buttons) === null || _a === void 0 ? void 0 : _a.forEach(function (button) {
            button.addEventListener('click', function () {
                _this.openModal();
            });
        });
    };
    FooterModal.prototype.clickListener = function () {
        var _this = this;
        this.modal.addEventListener('click', function (event) { return _this.checkForOutsideClick(event); });
    };
    FooterModal.prototype.openModal = function () {
        var _this = this;
        var _a, _b, _c, _d;
        (_a = StickyCTA_1.default.stickyCTAWrap) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_HIDDEN);
        (_b = this.buttonClose) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () { return _this.closeModal(); });
        this.clickListener();
        (_c = this.modal) === null || _c === void 0 ? void 0 : _c.classList.remove(constantsClasses_1.CLASS_DNONE);
        (_d = this.modal) === null || _d === void 0 ? void 0 : _d.classList.add(constantsClasses_1.CLASS_FADING_IN);
    };
    FooterModal.prototype.closeModal = function () {
        var _this = this;
        var _a, _b, _c;
        StickyCTA_1.default.resetStickyCTA();
        this.modal.classList.remove(constantsClasses_1.CLASS_FADING_IN);
        (_a = this.modal) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_FADING_OUT);
        (_b = this.buttonClose) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', function () { return _this.closeModal(); });
        (_c = this.modal) === null || _c === void 0 ? void 0 : _c.addEventListener('animationend', function () {
            if (_this.modal.classList.contains(constantsClasses_1.CLASS_FADING_IN))
                return;
            _this.modal.classList.add(constantsClasses_1.CLASS_DNONE);
            _this.modal.classList.remove(constantsClasses_1.CLASS_FADING_OUT);
        });
    };
    return FooterModal;
}(AbstractComponent_1.default));
exports.default = FooterModal;
